export default function TOS() {
  return (
    <>
      <main className='container relative z-[100] mx-auto font-sans text-white md:grid md:grid-cols-24 md:gap-0'>
        <div className='hidden xl:col-span-2 xl:block'></div>
        <div className='tos relative w-full max-w-7xl px-4 py-24 xs:px-8 md:col-span-24 md:mx-auto xl:col-span-20 xl:px-0'>
          <h1>Disclaimer & ToS</h1>
          <h2>Start Trading on Komodo Wallet</h2>
          <p>
            This End-User License Agreement (&apos;EULA&apos;) is a legal agreement between you and
            TillyHK Limited. The Platform https://komodoplatform.com and the platform specific
            domain is owned by TillyHK Limited.
          </p>
          <p>
            This EULA agreement governs your acquisition and use of our Komodo Wallet software
            (&apos;Software&apos;, &apos;Mobile Application&apos;, &apos;Application&apos; or
            &apos;App&apos;) directly from TillyHK Limited. or indirectly through a TillyHK Limited.
            authorized entity, reseller or distributor (a &apos;Distributor&apos;). Please read this
            EULA agreement carefully before completing the installation process and using the Komodo
            Wallet software. It provides a license to use the Komodo Wallet software and contains
            warranty information and liability disclaimers.
            <br />
            If you register for the beta program of the Komodo Wallet software, this EULA agreement
            will also govern that trial. By clicking &apos;accept&apos; or installing and/or using
            the Komodo Wallet software, you are confirming your acceptance of the Software and
            agreeing to become bound by the terms of this EULA agreement.
            <br />
            If you are entering into this EULA agreement on behalf of a company or other legal
            entity, you represent that you have the authority to bind such entity and its affiliates
            to these terms and conditions. If you do not have such authority or if you do not agree
            with the terms and conditions of this EULA agreement, do not install or use the
            Software, and you must not accept this EULA agreement.
            <br />
            This EULA agreement shall apply only to the Software supplied by TillyHK Limited.
            herewith regardless of whether other software is referred to or described herein. The
            terms also apply to any TillyHK Limited. updates, supplements, Internet-based services,
            and support services for the Software, unless other terms accompany those items on
            delivery. If so, those terms apply.
          </p>
          <h3>License Grant</h3>

          <p>
            TillyHK Limited. hereby grants you a personal, non-transferable, non-exclusive license
            to use the Komodo Wallet software on your devices in accordance with the terms of this
            EULA agreement.
          </p>
          <p>
            You are permitted to load the Komodo Wallet software (for example a PC, laptop, mobile
            or tablet) under your control. You are responsible for ensuring your device meets the
            minimum security and resource requirements of the Komodo Wallet software.
            <br />
            You are not permitted to:
            <br />
            Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the
            Software nor permit the whole or any part of the Software to be combined with or become
            incorporated in any other software, nor decompile, disassemble or reverse engineer the
            Software or attempt to do any such things
            <br />
            Reproduce, copy, distribute, resell or otherwise use the Software for any commercial
            purpose Use the Software in any way which breaches any applicable local, national or
            international law Use the Software for any purpose that TillyHK Limited. considers is a
            breach of this EULA agreement
            <br />
          </p>
          <h3>Intellectual Property and Ownership</h3>
          <p>
            TillyHK Limited. shall at all times retain ownership of the Software as originally
            downloaded by you and all subsequent downloads of the Software by you. The Software (and
            the copyright, and other intellectual property rights of whatever nature in the
            Software, including any modifications made thereto) are and shall remain the property of
            TillyHK Limited.
          </p>
          <p>
            TillyHK Limited. reserves the right to grant licenses to use the Software to third
            parties.
          </p>
          <h3>Termination</h3>
          <p>
            This EULA agreement is effective from the date you first use the Software and shall
            continue until terminated. You may terminate it at any time upon written notice to
            TillyHK Limited. It will also terminate immediately if you fail to comply with any term
            of this EULA agreement. Upon such termination, the licenses granted by this EULA
            agreement will immediately terminate and you agree to stop all access and use of the
            Software. The provisions that by their nature continue and survive will survive any
            termination of this EULA agreement.
            <br />
            Governing Law
            <br />
            This EULA agreement, and any dispute arising out of or in connection with this EULA
            agreement, shall be governed by and construed in accordance with the laws of Panama.
          </p>
          <p>This document was last updated on 23 of March 2022</p>
          <h2>Terms and Conditions: (Application User Agreement)</h2>
          <p>
            This disclaimer applies to the contents and services of the app Komodo Wallet and is
            valid for all users of the &quot;Application&quot; (&quot;Software&quot;, &quot;Mobile
            Application&quot;, &quot;Application&quot; or &quot;App&quot;).
          </p>
          <p>The Application is owned by TillyHK Limited.</p>
          <p>
            We reserve the right to amend the following Terms and Conditions (governing the use of
            the application &quot;Komodo Wallet&quot;) at any time without prior notice and at our
            sole discretion. It is your responsibility to periodically check this Terms and
            Conditions for any updates to these Terms, which shall come into force once published.
            <br />
            Your continued use of the application shall be deemed as acceptance of the following
            Terms. We are a company incorporated in Panama and these Terms and Conditions are
            governed by and subject to the laws of Panama.
            <br />
            If You do not agree with these Terms and Conditions, You must not use or access this
            software.
          </p>
          <h2>Terms and Conditions of Use and Disclaimer</h2>
          <h3>General Use</h3>
          <p>
            By entering into this User (each subject accessing or using the site) Agreement (this
            writing) You declare that You are an individual over the age of majority (at least 18 or
            older) and have the capacity to enter into this User Agreement and accept to be legally
            bound by the terms and conditions of this User Agreement, as incorporated herein and
            amended from time to time.
          </p>
          <h3>Modifications</h3>
          <p>
            We may change the terms of this User Agreement at any time. Any such changes will take
            effect when published in the application, or when You use the Services.
            <br />
            Read the User Agreement carefully every time You use our Services. Your continued use of
            the Services shall signify your acceptance to be bound by the current User Agreement.
            Our failure or delay in enforcing or partially enforcing any provision of this User
            Agreement shall not be construed as a waiver of any.
          </p>
          <h3>Limitations on Use</h3>
          <p>
            You are not allowed to decompile, decode, disassemble, rent, lease, loan, sell,
            sublicense, or create derivative works from the Komodo Wallet application or the user
            content. Nor are You allowed to use any network monitoring or detection software to
            determine the software architecture, or extract information about usage or
            individuals&apos; or users&apos; identities.
          </p>
          <p>
            You are not allowed to copy, modify, reproduce, republish, distribute, display, or
            transmit for commercial, non-profit or public purposes all or any portion of the
            application or the user content without our prior written authorization.
          </p>
          <h3>Accounts and Membership</h3>
          <p>
            If you create an account in the Mobile Application, you are responsible for maintaining
            the security of your account and you are fully responsible for all activities that occur
            under the account and any other actions taken in connection with it. We will not be
            liable for any acts or omissions by you, including any damages of any kind incurred as a
            result of such acts or omissions.
          </p>
          <p>
            Komodo Wallet is a non-custodial wallet implementation and thus TillyHK Limited. can not
            access nor restore your account in case of (data) loss.
          </p>
          <h3>Backups</h3>
          <p>
            We are not responsible for seed-phrases residing in the Mobile Application. In no event
            shall we be held liable for any loss of any kind. It is your sole responsibility to
            maintain appropriate backups of your accounts and their seedprases.
          </p>
          <h2>General Warning</h2>
          <p>
            You should not act, or refrain from acting solely on the basis of the content of this
            application.
            <br />
            Your access to this application does not itself create an adviser-client relationship
            between You and us.
            <br />
            The content of this application does not constitute a solicitation or inducement to
            invest in any financial products or services offered by us. Any advice included in this
            application has been prepared without taking into account your objectives, financial
            situation or needs. You should consider our Risk Disclosure Notice before making any
            decision on whether to acquire the product described in that document.
          </p>
          <h2>Access and Security</h2>
          <p>
            We do not guarantee your continuous access to the application or that your access or use
            will be error-free.
          </p>
          <p>
            We will not be liable in the event that the application is unavailable to You for any
            reason (for example, due to computer downtime ascribable to malfunctions, upgrades,
            server problems, precautionary or corrective maintenance activities or interruption in
            telecommunication supplies).
          </p>
          <h2>Intellectual Property Rights</h2>
          <p>
            TillyHK Limited. is the owner and/or authorised user of all trademarks, service marks,
            design marks, patents, copyrights, database rights and all other intellectual property
            appearing on or contained within the application, unless otherwise indicated. All
            information, text, material, graphics, software and advertisements on the application
            interface are copyright of TillyHK Limited., its suppliers and licensors, unless
            otherwise expressly indicated by TillyHK Limited.
            <br />
            Except as provided in the Terms, use of the application does not grant You any right,
            title, interest or license to any such intellectual property You may have access to on
            the application.
            <br />
            We own the rights, or have permission to use, the trademarks listed in our application.
            You are not authorised to use any of those trademarks without our written authorization
            - doing so would constitute a breach of our or another party&apos;s intellectual
            property rights.
            <br />
            Alternatively, we might authorise You to use the content in our application if You
            previously contact us and we agree in writing.
          </p>
          <h2>Disclaimer</h2>
          <p>
            TillyHK Limited. cannot guarantee the safety or security of your computer systems. We do
            not accept liability for any loss or corruption of electronically stored data or any
            damage to any computer system occurred in connection with the use of the application or
            of the user content.
            <br />
            TillyHK Limited. makes no representation or warranty of any kind, express or implied, as
            to the operation of the application or the user content. You expressly agree that your
            use of the application is entirely at your sole risk.
            <br />
            You agree that the content provided in the application and the user content do not
            constitute financial product, legal or taxation advice, and You agree on not
            representing the user content or the application as such.
            <br />
            To the extent permitted by current legislation, the application is provided on an “as
            is, as available” basis.
          </p>
          <p>
            TillyHK Limited. expressly disclaims all responsibility for any loss, injury, claim,
            liability, or damage, or any indirect, incidental, special or consequential damages or
            loss of profits whatsoever resulting from, arising out of or in any way related to:
            <br />
            (a) any errors in or omissions of the application and/or the user content, including but
            not limited to technical inaccuracies and typographical errors;
            <br />
            (b) any third party website, application or content directly or indirectly accessed
            through links in the application, including but not limited to any errors or omissions;
            <br />
            (c) the unavailability of the application or any portion of it;
            <br />
            (d) your use of the application;
            <br />
            (e) your use of any equipment or software in connection with the application. Any
            Services offered in connection with the Platform are provided on an &apos;as is&apos;
            basis, without any representation or warranty, whether express, implied or statutory. To
            the maximum extent permitted by applicable law, we specifically disclaim any implied
            warranties of title, merchantability, suitability for a particular purpose and/or
            non-infringement. We do not make any representations or warranties that use of the
            Platform will be continuous, uninterrupted, timely, or error-free.
            <br />
            We make no warranty that any Platform will be free from viruses, malware, or other
            related harmful material and that your ability to access any Platform will be
            uninterrupted. Any defects or malfunction in the product should be directed to the third
            party offering the Platform, not to Komodo.
            <br />
            We will not be responsible or liable to You for any loss of any kind, from action taken,
            or taken in reliance on the material or information contained in or through the
            Platform. This is experimental and unfinished software. Use at your own risk. No
            warranty for any kind of damage. By using this application you agree to this terms and
            conditions.
          </p>
          <h2>Representations and Warranties, Indemnification, and Limitation of Liability</h2>
          <p>
            When accessing or using the Services, You agree that You are solely responsible for your
            conduct while accessing and using our Services. Without limiting the generality of the
            foregoing, You agree that You will not:
            <br />
            (a) Use the Services in any manner that could interfere with, disrupt, negatively affect
            or inhibit other users from fully enjoying the Services, or that could damage, disable,
            overburden or impair the functioning of our Services in any manner;
            <br />
            (b) Use the Services to pay for, support or otherwise engage in any illegal activities,
            including, but not limited to illegal gambling, fraud, money laundering, or terrorist
            activities;
            <br />
            (c) Use any robot, spider, crawler, scraper or other automated means or interface not
            provided by us to access our Services or to extract data;
            <br />
            (d) Use or attempt to use another user&apos;s Wallet or credentials without
            authorization;
            <br />
            (e) Attempt to circumvent any content filtering techniques we employ, or attempt to
            access any service or area of our Services that You are not authorized to access;
            <br />
            (f) Introduce to the Services any virus, Trojan, worms, logic bombs or other harmful
            material;
            <br />
            (g) Develop any third-party applications that interact with our Services without our
            prior written consent;
            <br />
            (h) Provide false, inaccurate, or misleading information;
            <br />
            (i) Encourage or induce any other person to engage in any of the activities prohibited
            under this Section.
          </p>
          <h2>General Risk Factors</h2>
          <p>
            You agree and understand that there are risks associated with utilizing Services
            involving Virtual Currencies including, but not limited to, the risk of failure of
            hardware, software and internet connections, the risk of malicious software
            introduction, and the risk that third parties may obtain unauthorized access to
            information stored within your Wallet, including but not limited to your public and
            private keys. You agree and understand that TillyHK Limited. will not be responsible for
            any communication failures, disruptions, errors, distortions or delays You may
            experience when using the Services, however caused.
            <br />
            You accept and acknowledge that there are risks associated with utilizing any virtual
            currency network, including, but not limited to, the risk of unknown vulnerabilities in
            or unanticipated changes to the network protocol. You acknowledge and accept that
            TillyHK Limited. has no control over any cryptocurrency network and will not be
            responsible for any harm occurring as a result of such risks, including, but not limited
            to, the inability to reverse a transaction, and any losses in connection therewith due
            to erroneous or fraudulent actions.
            <br />
            The risk of loss in using Services involving Virtual Currencies may be substantial and
            losses may occur over a short period of time. In addition, price and liquidity are
            subject to significant fluctuations that may be unpredictable.
            <br />
            Virtual Currencies are not legal tender and are not backed by any sovereign government.
            In addition, the legislative and regulatory landscape around Virtual Currencies is
            constantly changing and may affect your ability to use, transfer, or exchange Virtual
            Currencies. CFDs are complex instruments and come with a high risk of losing money
            rapidly due to leverage. 80.6% of retail investor accounts lose money when trading CFDs
            with this provider. You should consider whether You understand how CFDs work and whether
            You can afford to take the high risk of losing your money.
          </p>
          <h2>Indemnification</h2>
          <p>
            You agree to indemnify, defend and hold harmless TillyHK Limited., its officers,
            directors, employees, agents, licensors, suppliers and any third party information
            providers to the application from and against all losses, expenses, damages and costs,
            including reasonable lawyer fees, resulting from any violation of the Terms by You.
            <br />
            You also agree to indemnify TillyHK Limited. against any claims that information or
            material which You have submitted to TillyHK Limited. is in violation of any law or in
            breach of any third party rights (including, but not limited to, claims in respect of
            defamation, invasion of privacy, breach of confidence, infringement of copyright or
            infringement of any other intellectual property right).
          </p>
          <h2>Risk Disclosures Relating to the Wallet</h2>
          <p>
            In order to be completed, any Virtual Currency transaction created with the TillyHK
            Limited. must be confirmed and recorded in the Virtual Currency ledger associated with
            the relevant Virtual Currency network. Such networks are decentralized, peer-to-peer
            networks supported by independent third parties, which are not owned, controlled or
            operated by TillyHK Limited.
            <br />
            TillyHK Limited. has no control over any Virtual Currency network and therefore cannot
            and does not ensure that any transaction details You submit via our Services will be
            confirmed on the relevant Virtual Currency network. You agree and understand that the
            transaction details You submit via our Services may not be completed, or may be
            substantially delayed, by the Virtual Currency network used to process the transaction.
            We do not guarantee that the Wallet can transfer title or right in any Virtual Currency
            or make any warranties whatsoever with regard to title.
            <br />
            Once transaction details have been submitted to a Virtual Currency network, we cannot
            assist You to cancel or otherwise modify your transaction or transaction details.
            TillyHK Limited. has no control over any Virtual Currency network and does not have the
            ability to facilitate any cancellation or modification requests.
            <br />
            In the event of a Fork, TillyHK Limited. may not be able to support activity related to
            your Virtual Currency. You agree and understand that, in the event of a Fork, the
            transactions may not be completed, completed partially, incorrectly completed, or
            substantially delayed. TillyHK Limited. is not responsible for any loss incurred by You
            caused in whole or in part, directly or indirectly, by a Fork.
            <br />
            In no event shall TillyHK Limited., its affiliates and service providers, or any of
            their respective officers, directors, agents, employees or representatives, be liable
            for any lost profits or any special, incidental, indirect, intangible, or consequential
            damages, whether based on contract, tort, negligence, strict liability, or otherwise,
            arising out of or in connection with authorized or unauthorized use of the services, or
            this agreement, even if an authorized representative of TillyHK Limited. has been
            advised of, has known of, or should have known of the possibility of such damages. For
            example (and without limiting the scope of the preceding sentence), You may not recover
            for lost profits, lost business opportunities, or other types of special, incidental,
            indirect, intangible, or consequential damages. Some jurisdictions do not allow the
            exclusion or limitation of incidental or consequential damages, so the above limitation
            may not apply to You.
            <br />
            We will not be responsible or liable to You for any loss and take no responsibility for
            damages or claims arising in whole or in part, directly or indirectly from:
            <br /> (a) user error such as forgotten passwords, incorrectly constructed transactions,
            or mistyped Virtual Currency addresses;
            <br /> (b) server failure or data loss;
            <br /> (c) corrupted or otherwise non-performing Wallets or Wallet files;
            <br /> (d) unauthorized access to applications;
            <br /> (e) any unauthorized activities, including without limitation the use of hacking,
            viruses, phishing, brute forcing or other means of attack against the Services.
          </p>
          <h2>No Investment Advice or Brokerage</h2>
          <p>
            For the avoidance of doubt, TillyHK Limited. does not provide investment, tax or legal
            advice, nor does TillyHK Limited. broker trades on your behalf. All TillyHK Limited.
            trades are executed automatically, based on the parameters of your order instructions
            and in accordance with posted Trade execution procedures, and You are solely responsible
            for determining whether any investment, investment strategy or related transaction is
            appropriate for You based on your personal investment objectives, financial
            circumstances and risk tolerance. You should consult your legal or tax professional
            regarding your specific situation.Neither Komodo nor its owners, members, officers,
            directors, partners, consultants, nor anyone involved in the publication of this
            application, is a registered investment adviser or broker-dealer or associated person
            with a registered investment adviser or broker-dealer and none of the foregoing make any
            recommendation that the purchase or sale of crypto-assets or securities of any company
            profiled in the mobile Application is suitable or advisable for any person or that an
            investment or transaction in such crypto-assets or securities will be profitable. The
            information contained in the mobile Application is not intended to be, and shall not
            constitute, an offer to sell or the solicitation of any offer to buy any crypto-asset or
            security. The information presented in the mobile Application is provided for
            informational purposes only and is not to be treated as advice or a recommendation to
            make any specific investment or transaction. Please, consult with a qualified
            professional before making any decisions.The opinions and analysis included in this
            applications are based on information from sources deemed to be reliable and are
            provided “as is” in good faith. Komodo makes no representation or warranty, expressed,
            implied, or statutory, as to the accuracy or completeness of such information, which may
            be subject to change without notice. Komodo shall not be liable for any errors or any
            actions taken in relation to the above. Statements of opinion and belief are those of
            the authors and/or editors who contribute to this application, and are based solely upon
            the information possessed by such authors and/or editors. No inference should be drawn
            that Komodo or such authors or editors have any special or greater knowledge about the
            crypto-assets or companies profiled or any particular expertise in the industries or
            markets in which the profiled crypto-assets and companies operate and
            compete.Information on this application is obtained from sources deemed to be reliable;
            however, Komodo takes no responsibility for verifying the accuracy of such information
            and makes no representation that such information is accurate or complete. Certain
            statements included in this application may be forward-looking statements based on
            current expectations. Komodo makes no representation and provides no assurance or
            guarantee that such forward-looking statements will prove to be accurate.Persons using
            the Komodo application are urged to consult with a qualified professional with respect
            to an investment or transaction in any crypto-asset or company profiled herein.
            Additionally, persons using this application expressly represent that the content in
            this application is not and will not be a consideration in such persons&apos; investment
            or transaction decisions. Traders should verify independently information provided in
            the Komodo application by completing their own due diligence on any crypto-asset or
            company in which they are contemplating an investment or transaction of any kind and
            review a complete information package on that crypto-asset or company, which should
            include, but not be limited to, related blog updates and press releases.Past performance
            of profiled crypto-assets and securities is not indicative of future results.
            Crypto-assets and companies profiled on this site may lack an active trading market and
            invest in a crypto-asset or security that lacks an active trading market or trade on
            certain media, platforms and markets are deemed highly speculative and carry a high
            degree of risk. Anyone holding such crypto-assets and securities should be financially
            able and prepared to bear the risk of loss and the actual loss of his or her entire
            trade. The information in this application is not designed to be used as a basis for an
            investment decision. Persons using the Komodo application should confirm to their own
            satisfaction the veracity of any information prior to entering into any investment or
            making any transaction. The decision to buy or sell any crypto-asset or security that
            may be featured by Komodo is done purely and entirely at the reader&apos;s own risk. As
            a reader and user of this application, You agree that under no circumstances will You
            seek to hold liable owners, members, officers, directors, partners, consultants or other
            persons involved in the publication of this application for any losses incurred by the
            use of information contained in this applicationKomodo and its contractors and
            affiliates may profit in the event the crypto-assets and securities increase or decrease
            in value. Such crypto-assets and securities may be bought or sold from time to time,
            even after Komodo has distributed positive information regarding the crypto-assets and
            companies.
            <br />
            Komodo has no obligation to inform readers of its trading activities or the trading
            activities of any of its owners, members, officers, directors, contractors and
            affiliates and/or any companies affiliated with BC Relations&apos; owners, members,
            officers, directors, contractors and affiliates.Komodo and its affiliates may from time
            to time enter into agreements to purchase crypto-assets or securities to provide a
            method to reach their goals.
          </p>
          <h2>Termination</h2>
          <p>
            The Terms are effective until terminated by TillyHK Limited.
            <br />
            In the event of termination, You are no longer authorized to access the Application, but
            all restrictions imposed on You and the disclaimers and limitations of liability set out
            in the Terms will survive termination.
            <br />
            Such termination shall not affect any legal right that may have accrued to TillyHK
            Limited. against You up to the date of termination.
            <br />
            TillyHK Limited. may also remove the Application as a whole or any sections or features
            of the Application at any time.
          </p>
          <h2>Third Party Rights</h2>
          <p>
            The provisions of previous paragraphs are for the benefit of TillyHK Limited. and its
            officers, directors, employees, agents, licensors, suppliers, and any third party
            information providers to the Application. Each of these individuals or entities shall
            have the right to assert and enforce those provisions directly against You on its own
            behalf.
          </p>
          <h3>Our Legal Obligations</h3>
          <p>
            Komodo Wallet is a non-custodial, decentralized and blockchain based application and as
            such does TillyHK Limited. never store any user-data (accounts and authentication data).
            We also collect and process non-personal, anonymized data for statistical purposes and
            analysis and to help us provide a better service.
            <br />
            This document was last updated on 23 of March 2022
          </p>
        </div>
        <div className='hidden xl:col-span-2 xl:block'></div>
      </main>
    </>
  );
}
